import { ViewStorePageProps } from './view-store-page.types'
import styles from './view-store-page.module.scss'
import cl from 'classnames'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'mobx-stores/store-provider'
import { useEffect, useRef } from 'react'
import { StoreDetailsSection } from './store-details-section'
import { StoreImageSection } from './store-image-section'
import { StoreAttributesSection } from './store-attributes-section'
import { StoreShippingsSection } from './store-shippings-sections'
import { PageContainer } from 'components'
import { PageHeader } from '@touche-lts/panel-ui/dist/components/shared/page-header'
import { IconStores } from '@touche-lts/panel-ui/dist/components/icons/icon-stores'

const ViewStorePageComponent = (props: ViewStorePageProps) => {
  const {
    className,
    style,
    match: {
      params: { storeId }
    }
  } = props

  const {
    userStore: { assignedStoreId, setManagementStoreId },
    viewStorePageStore: { onPageMount, clearStore, store }
  } = useRootStore()

  const MyStoreContainerRef = useRef<HTMLDivElement>();

  useEffect(() => {
    setManagementStoreId(storeId)
  }, [storeId, setManagementStoreId])

  useEffect(() => {
    const id = storeId || assignedStoreId
    if (id) onPageMount(id)
    return clearStore
  }, [onPageMount, storeId, clearStore, assignedStoreId])

  if (!store) return null

  return (
    <PageContainer className={cl(className, styles.scrollable, styles.myStoreContainer)} style={style}> {/* Left Side Margin for Prevent Overlap from Sidebar */}
      <div ref={MyStoreContainerRef} className={cl('container', styles.container)}>
        <PageHeader
          colorPreset='dark'
          navSegments={[
            {
              label: 'My Store',
              icon: IconStores,
              iconProps: { style: { marginBottom: -5 } }
            }
          ]}
        />
        <StoreDetailsSection MyStoreContainerRef={MyStoreContainerRef} />
        <StoreImageSection className={styles.section} />
        <StoreAttributesSection className={styles.section} />
        <StoreShippingsSection className={styles.section} />
      </div>
    </PageContainer>
  )
}

const ViewStorePage = observer(ViewStorePageComponent)
export { ViewStorePage }
